import { useMemo, useState } from "react";
import Button from "components/button";
import LoaderButton from "components/button/LoaderButton";
import Modal from "components/modal";
import { useDispatch, useSelector } from "react-redux";
import { changeOrderStatus } from "store/orderSlice";
import { ORDER_STATUS } from "constants";
import { showToast } from "components/toast";

const OrderConfirmModal = ({ data, refreshList, isComfirm }) => {
  const dispatch = useDispatch();
  const { orderChangeStatusError, orderChangeStatusLoading, orderStatusData } =
    useSelector((state) => state.orders);

  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  // ✅ Decide next status based on isComfirm
  const nextStatus = isComfirm
    ? ORDER_STATUS.PROCESSING // confirm = move to processing
    : ORDER_STATUS.CANCELLED; // cancel = move to cancelled

  // ✅ Get matching statusId from orderStatusData
  const nextStatusData = useMemo(() => {
    if (!orderStatusData?.length) return null;
    return orderStatusData.find((s) => s.enumVal === nextStatus) || null;
  }, [orderStatusData, nextStatus]);

  const handleChangeStatus = async () => {
    if (!data?._id || !nextStatusData?._id) return;

    try {
      const res = await dispatch(
        changeOrderStatus({ _id: data._id, status: nextStatusData._id })
      ).unwrap();
      console.log("res: ", res);

      if (res?.statuscode === 200) {
        showToast.success(`Order ${nextStatusData.name} successfully!`);
        refreshList?.();
        closeModal();
      } else {
        showToast.error(
          `Failed to change order to ${
            nextStatusData.name || "selected status"
          }`
        );
      }
    } catch (error) {
      console.error("Order status change failed:", error);
      showToast.error("Something went wrong while changing order status!");
    }
  };

  return (
    <>
      <Button
        type="button"
        variant={isComfirm ? "green" : "red"}
        onClick={openModal}
      >
        {isComfirm ? "Confirm" : "Cancel"}
      </Button>

      <Modal isOpen={isOpen} onClose={closeModal} className="max-w-lg">
        <h2 className="border-b py-3 pl-2 text-xl font-bold text-navy-700 dark:text-white">
          {isComfirm ? "Confirm Order" : "Cancel Order"}
        </h2>

        <div className="relative w-full rounded-3xl p-4 lg:p-5">
          <p className="mb-6 text-sm text-gray-600 dark:text-gray-400">
            {isComfirm
              ? "Are you sure you want to confirm this order and move it to Processing?"
              : "Are you sure you want to cancel this order?"}
          </p>

          {orderChangeStatusError && (
            <div className="mt-2">
              <p className="text-sm text-red-500">{orderChangeStatusError}</p>
            </div>
          )}

          <div className="mt-6 flex items-center justify-end gap-3">
            <Button type="button" variant="outline" onClick={closeModal}>
              Cancel
            </Button>

            <LoaderButton
              type="button"
              isLoading={orderChangeStatusLoading}
              onClick={handleChangeStatus}
              disabled={!nextStatusData?._id}
            >
              {isComfirm ? "Confirm & Process" : "Confirm Cancel"}
            </LoaderButton>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default OrderConfirmModal;
